"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = require("axios");
const client_1 = __importDefault(require("../../client"));
const path = '/event';
function getEvent(event, options) {
    const id = event.split(':')[1];
    const headers = new axios_1.AxiosHeaders({});
    if ((options === null || options === void 0 ? void 0 : options.token) !== undefined) {
        headers.set('Authorization', options.token);
    }
    return client_1.default.get(`${path}/${id}`, { headers });
}
exports.default = getEvent;
